import { render, staticRenderFns } from "./VacationTab.vue?vue&type=template&id=a19c35a8&"
import script from "./VacationTab.vue?vue&type=script&lang=js&"
export * from "./VacationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19c35a8')) {
      api.createRecord('a19c35a8', component.options)
    } else {
      api.reload('a19c35a8', component.options)
    }
    module.hot.accept("./VacationTab.vue?vue&type=template&id=a19c35a8&", function () {
      api.rerender('a19c35a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/VacationTab.vue"
export default component.exports